import React, { useEffect, useState } from "react";
import Button from "./ui/Button";

/**
 * Prévisualisation du découpage AVANT indexation.
 *
 * Aucun pipeline ne sera parfait sur des maquettes arbitraires : une brochure
 * mêle colonnes, encadrés et infographies, et il reste toujours quelques
 * segments mélangés. Plutôt que de viser une automatisation totale illusoire,
 * on rend le découpage VISIBLE : l'opérateur voit ce qui sera écrit, décoche ce
 * qui n'a pas de sens, puis valide.
 *
 * Un problème invisible et permanent devient une correction de deux minutes.
 *
 * Ce composant est purement présentatif : il reçoit les segments et rend la
 * liste retenue. C'est DocumentIndexer qui les obtient et qui les envoie, parce
 * que c'est lui qui pilote l'avancement — les deux ne doivent pas se disputer
 * la responsabilité de l'écriture.
 */
export default function SegmentPreview({ segments, engine, duplicates = 0, disabled, onConfirm }) {
    const [rejected, setRejected] = useState({});

    /* Un nouveau découpage repart d'une sélection vierge.
       Un décochage automatique des blocs de maquette a été essayé puis retiré :
       sur une brochure réelle, 49 lignes signalées et aucune illégitime — les
       titres de section étaient pris pour de l'habillage. Tout recocher coûtait
       plus que de décocher soi-même. */
    useEffect(() => { setRejected({}); }, [segments]);

    if (!segments || segments.length === 0) {
        return <p className="empty">Aucun segment exploitable dans ce document.</p>;
    }

    const toggle = (i) => setRejected(prev => ({ ...prev, [i]: !prev[i] }));
    const kept = segments.filter((_, i) => !rejected[i]);

    return (
        <div className="segment-preview">
            <p className="preview-summary">
                <strong>{kept.length}</strong> segment(s) retenu(s) sur {segments.length}
                {engine && <> — extraction&nbsp;: {engine}</>}
                {duplicates > 0 && (
                    <> — {duplicates} répétition(s) écartée(s)</>
                )}
                <br />
                Décochez les lignes qui n'ont pas de sens (titres coupés, colonnes
                mélangées, mentions de pied de page) avant de valider.
            </p>

            <ol className="preview-list">
                {segments.map((s, i) => (
                    <li key={i} className={rejected[i] ? "is-rejected" : ""}>
                        <label>
                            <input
                                type="checkbox"
                                checked={!rejected[i]}
                                disabled={disabled}
                                onChange={() => toggle(i)}
                            />
                            <span>{s}</span>
                        </label>
                    </li>
                ))}
            </ol>

            <div className="preview-actions">
                <Button type="button" onClick={() => onConfirm(kept)}
                        disabled={disabled || kept.length === 0}>
                    Indexer les {kept.length} segment(s) retenu(s)
                </Button>
            </div>
        </div>
    );
}
